export default function VerticalDivider({ x }: { x: number }) {
  return (
    <>
      <div
        className="pointer-events-none absolute bottom-0 left-[calc(50%-20px)] top-0 flex w-10 items-center"
        style={{
          transform: `translateX(${x}px)`,
          background: 'linear-gradient(to bottom, #ffffff 0%, #ffffff 100%)',
          backgroundSize: '2px 100%',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
        }}
      ></div>
    </>
  );
}
